"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _constants = require("../constants");
var _FormatCurrency = _interopRequireDefault(require("../../currency/FormatCurrency"));
var _MediaContext = require("../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StickyNavbar = /*#__PURE__*/function (_Component) {
  function StickyNavbar() {
    var _this;
    (0, _classCallCheck2["default"])(this, StickyNavbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StickyNavbar, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      visible: false,
      isIntercom: false
    });
    (0, _defineProperty2["default"])(_this, "updateIntercom", function () {
      return _this.setState({
        isIntercom: true
      });
    });
    (0, _defineProperty2["default"])(_this, "handleScroll", function () {
      _this.setState({
        visible: true
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(StickyNavbar, _Component);
  return (0, _createClass2["default"])(StickyNavbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.staticPosition) {
        var navbarHeight = this.stickyNavbarEl && this.stickyNavbarEl.getBoundingClientRect().height;
        document.body.style.paddingBottom = "".concat(navbarHeight, "px");
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!this.props.staticPosition) {
        if (prevState.visible !== this.state.visible) {
          window.removeEventListener('scroll', this.handleScroll);
        }
      }
      if (prevState.isIntercom === false) {
        if (window.Intercom) this.updateIntercom();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.staticPosition) {
        document.body.style.paddingBottom = '';
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isIntercom = this.state.isIntercom;
      var _this$props = this.props,
        staticPosition = _this$props.staticPosition,
        price = _this$props.price,
        buttonText = _this$props.buttonText,
        buttonLink = _this$props.buttonLink,
        topText = _this$props.topText,
        button = _this$props.button,
        showCookieBanner = _this$props.showCookieBanner,
        extraText = _this$props.extraText,
        className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(el) {
          return _this2.stickyNavbarEl = el;
        },
        className: (0, _classnames["default"])('d8-c-sticky-navbar position-sticky d8-u-zindex-fixed-element', staticPosition && 'position-relative', !this.state.visible && !staticPosition && '--hidden', showCookieBanner && 'is-cookie-banner', className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "max-width-lg container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "sticky-navbar flex items-center justify-between"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "sticky-navbar__left"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm d8-u-color-contrast-high d8-u-text-uppercase d8-u-ls-sm"
      }, topText), !!price && Number.isFinite(price) ? /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-md d8-u-ls-sm"
      }, "from", ' ', /*#__PURE__*/_react["default"].createElement(_FormatCurrency["default"], {
        amount: typeof price !== 'number' ? parseFloat(price.replace(/[^\d.]/g, '')) : price,
        baseCurrency: "EUR"
      }), "pp") : /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-md d8-u-ls-sm"
      }, price), extraText && /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-ls-sm text-sm"
      }, extraText), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
        lessThan: _constants.BREAKPOINTS.XS
      }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, buttonLink && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        href: buttonLink
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-ls-sm"
      }, buttonText), /*#__PURE__*/_react["default"].createElement("span", {
        className: "margin-left-sm",
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        name: "arrow-right",
        fill: ""
      })))), button))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
        greaterThanOrEqual: _constants.BREAKPOINTS.XS
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "sticky-navbar__right"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        link: buttonLink,
        text: buttonText,
        buttonType: _constants.BUTTON_TYPES.SECONDARY
      }), button, isIntercom ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "sticky-navbar-intercom"
      }) : null)))));
    }
  }]);
}(_react.Component);
StickyNavbar.propTypes = {
  price: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object]),
  buttonText: _propTypes["default"].string,
  buttonLink: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  button: _propTypes["default"].object,
  extraText: _propTypes["default"].string,
  showCookieBanner: _propTypes["default"].bool,
  staticPosition: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = exports["default"] = StickyNavbar;